export default __webpack_public_path__ + "static/media/330_business03-nl-web.f6c53b5f.png";